import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, filter, switchMap, take } from 'rxjs/operators';
import { Idea } from 'src/app/core/models/idea.models';
import { AuthStoreService } from 'src/app/core/store/services/auth-store.service';
import { IdeasTrackStoreService } from 'src/app/core/store/services/ideas-store.track.service';

@Component({
  selector: 'craft-track-button',
  templateUrl: './craft-track-button.component.html',
  styleUrls: ['./craft-track-button.component.scss'],
  standalone: false,
})
export class CraftTrackButtonComponent implements OnInit, OnDestroy {
  @Input() public idea: Readonly<Idea>;
  @Input() public disabled = false;

  public clicks = new Subject<MouseEvent>();

  private clicksSub: Subscription;

  constructor(
    private authStore: AuthStoreService, //
    private ideasTrackStore: IdeasTrackStoreService,
  ) {}

  public ngOnInit() {
    this.clicksSub = this.clicks
      .pipe(
        filter((event) => event.button === 0 && !!this.idea.id),
        debounceTime(500),
        switchMap(() => {
          return this.authStore.isAuthenticated$.pipe(take(1));
        }),
        filter((isAuthenticated) => isAuthenticated),
        switchMap(() => {
          if (this.idea.isTracked) {
            return this.ideasTrackStore.untrack(this.idea.id!);
          }
          return this.ideasTrackStore.track(this.idea.id!);
        }),
      )
      .subscribe();
  }

  public ngOnDestroy() {
    this.clicksSub.unsubscribe();
  }
}
